import apiClient from './client.js';
const base = (wsId) => `/workspaces/${wsId}/import-export`;
export const listImports = (wsId) => apiClient.get(`${base(wsId)}/imports`).then(r => r.data);
export const createImport = (wsId, dto) => apiClient.post(`${base(wsId)}/imports`, dto).then(r => r.data);
export const getImport = (wsId, id) => apiClient.get(`${base(wsId)}/imports/${id}`).then(r => r.data);
export const listExports = (wsId) => apiClient.get(`${base(wsId)}/exports`).then(r => r.data);
export const createExport = (wsId, dto) => apiClient.post(`${base(wsId)}/exports`, dto).then(r => r.data);
export const getExport = (wsId, id) => apiClient.get(`${base(wsId)}/exports/${id}`).then(r => r.data);
export const mergeDuplicates = (wsId, dto) => apiClient.post(`${base(wsId)}/merge`, dto).then(r => r.data);
